import { uniqBy, propOr, chain, prop, pipe } from 'ramda';

const getProductFamilies = pipe(propOr([], 'journeys'), chain(prop('fares')), chain(prop('productFamily')));

const Offers = {
  productFamiliesWithFares: ({ outbound, inbound }) => {
    const allProductFamilies = chain(getProductFamilies, [outbound, inbound]);

    return uniqBy((p) => p.code, allProductFamilies).filter((p) => p.code !== null);
  }
};

export default Offers;
